import React from 'react';
import { Chip, ChipProps } from '@mui/material';
import { StatusColor } from '../../../../util/constants';

interface Props {
  color: StatusColor;
  icon?: JSX.Element;
  label: string;
  size?: 'small' | 'medium';
  textOnly?: boolean;
}

export const BaseStatusChip = ({
  icon,
  color,
  label,
  size = 'small',
  textOnly = false,
  ...props
}: Props & Omit<ChipProps, 'color'>) => (
  <Chip
    {...props}
    icon={icon}
    sx={{
      backgroundColor: textOnly ? 'rgba(0, 0, 0, 0)' : color.bg,
      color: color.text,
      borderRadius: '10px',
      textTransform: 'uppercase',
      padding: textOnly ? 0 : 0.5,

      '& .MuiChip-icon': {
        color: color.text,
        fontSize: '12px',
      },
      ...(size === 'small' && {
        fontSize: '10px',
        fontWeight: 500,
      }),
      ...(size === 'medium' && {
        fontSize: '14px',
        fontWeight: 600,
      }),
      ...(textOnly && {
        '& .MuiChip-icon': {
          display: 'none',
        },
        '& .MuiChip-label': {
          padding: 0,
          fontWeight: 500,
        },
      }),
      ...props.sx,
    }}
    label={label}
    size={size}
  />
);
